import axios from 'axios';
import TokenService from './token.service';
import { attachAuthRefreshInterceptor } from './authInterceptor';

const baseURL = process.env.REACT_APP_API_URL;

const examAPI = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
    accept: 'application/json',
    'Accept-Language': localStorage.getItem('i18nextLng'),
  },
});

examAPI.interceptors.request.use(
  (config) => {
    const token = TokenService.getLocalAccessToken();
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

attachAuthRefreshInterceptor(examAPI, [
  '/auth/login',
  '/core/transfer_students/',
]);

export default examAPI;
